var s = "_icon_1q1xv_1",
    c = "_successCopy_18azp_3",
    o = {
  icon: s,
  successCopy: c
};
export { o as default, s as icon, c as successCopy };